import styled, { css } from 'styled-components';
import { lighten } from 'polished';
import theme from '@styles/theme';

// 가로 스크롤이 필요할 떄 사용. 최상위 테이블 DOM. TableHeader, TableBody의 부모로 쓸 것
export const TableWrapper = styled.div<{
    $maxWidth?: number;
}>`
    max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 1117)}px;
    width: 100%;
    overflow-x: auto;
    &::-webkit-scrollbar {
        height: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
`;

export const TableBody = styled.ul<{
    $maxWidth?: number;
    $height?: number;
    $minHeight?: number;
}>`
    width: 100%;
    max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 1117)}px;
    min-height: 200px;

    ${({ $height }) =>
        $height &&
        css`
            height: ${$height}px;
            overflow-y: auto;
        `};

    ${({ $minHeight }) =>
        $minHeight &&
        css`
            min-height: ${$minHeight}px;
            overflow-y: auto;
        `};
`;

export const TableRow = styled.li<{
    $disabled?: boolean;
    $default?: boolean;
    $scroll?: boolean;
    $isDragging?: boolean;
}>`
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};
    opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
    cursor: pointer;

    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }

    ${({ $disabled }) =>
        $disabled &&
        css`
            cursor: initial;
            &:hover {
                background-color: ${theme.colors.whiteColor};
            }

            & * {
                color: ${theme.colors.lightGrayFontColor};
            }
        `}
    // 리스트 상세가 없는 경우 
    ${({ $default }) =>
        $default &&
        css`
            cursor: initial;

            &:hover {
                background-color: ${theme.colors.whiteColor};
            }
        `}

    ${({ $scroll }) =>
        $scroll &&
        css`
            width: fit-content;
        `}
`;
export const TableCell = styled.div<{
    $minWidth: number;
    $width?: number;
    $cursor?: boolean;
    $fontColor?: string;
}>`
    position: relative;

    padding-right: 20px;
    min-width: ${({ $minWidth }) => $minWidth}px;
    width: ${({ $width, $minWidth }) =>
        $width ? `${$width}%` : `${$minWidth}px`};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: PretendardRegular, sans-serif;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    font-size: 14px;
    &:first-child {
        padding-left: 20px;
    }

    ${({ $cursor }) =>
        $cursor &&
        css`
            cursor: pointer;
            transition: 0.25s;
            &:hover {
                color: ${lighten(0.3, theme.colors.blackColor)};
            }
        `}
`;

export const TableTooltip = styled.div<{ $withButton?: boolean }>`
    // css 참고 사이트
    // https://projects.verou.me/bubbly
    position: absolute;
    top: -250%;
    left: 50%;
    transform: translateX(-50%);
    display: none;
    padding: 8px;
    background-color: ${theme.colors.activeBlue};
    color: ${theme.colors.whiteColor};
    font-size: 11px;
    border-radius: 4px;
    z-index: 10;

    ${({ $withButton }) =>
        $withButton &&
        css`
            top: -80%;
        `}

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-top-color: ${theme.colors.activeBlue};
        border-bottom: 0;
        margin-left: -4px;
        margin-bottom: -4px;
    }
    // 첫번째 테이블 리스트 툴팁 하단 노출
    ${TableRow}:first-child & {
        top: 150%;
        ${({ $withButton }) =>
            $withButton &&
            css`
                top: 100%;
            `}
        &:after {
            content: '';
            top: 0;
            bottom: auto;
            border: 4px solid transparent;
            border-top-color: none;
            border-bottom-color: ${theme.colors.activeBlue};
            border-bottom: auto;
            border-top: 0;
            margin-bottom: auto;
            margin-top: -4px;
        }
    }
`;

export const TableText = styled.div`
    padding-right: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.5;

    ${TableCell}:last-child & {
        padding-right: 10px;
    }

    &:hover ~ ${TableTooltip} {
        display: inline-block;
    }
`;

export const EmptyTable = styled.li`
    height: 100px;
    color: ${theme.colors.deepGrayFontColor};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TableImg = styled.img<{ $width?: number; $height?: number }>`
    display: block;
    margin-right: 20px;
    width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
    height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
    border: ${theme.colors.lightGrayBorder} 1px solid;
    border-radius: 4px;
`;
